import React, { useState, useEffect, useRef } from 'react';
import { auth, db } from '../firebase';
import { 
  doc, 
  getDoc, 
  updateDoc, 
  serverTimestamp,
  setDoc,
  collection,
  addDoc,
  query,
  where,
  getDocs
} from 'firebase/firestore';
import { onAuthStateChanged } from 'firebase/auth';
import { 
  Bot, 
  X, 
  Send, 
  Brain,
  ChevronRight,
  Lock,
  CheckCircle2,
  PlayCircle,
  BookOpen,
  Code2,
  BarChart3,
  Video,
  Play,
  Loader2,
  AlertCircle,
  Trophy,
  Target,
  Zap,
  RefreshCw,
  Edit3,
  ExternalLink,
  Lock as LockIcon
} from 'lucide-react';
import '../styles/AI.css';

import Editor from './Editor';

import { topicai1 } from '../data/topicai1';
import { topicai2 } from '../data/topicai2';
import { topicai3 } from '../data/topicai3';
import { topicai4 } from '../data/topicai4';
import { topicai5 } from '../data/topicai5';
import { topicai6 } from '../data/topicai6';
import { topicai7 } from '../data/topicai7';
import { topicai8 } from '../data/topicai8';
import { topicai9 } from '../data/topicai9';
import { topicai10 } from '../data/topicai10';
import { topicai11 } from '../data/topicai11';
import { topicai12 } from '../data/topicai12';
import { topicai13 } from '../data/topicai13';
import { topicai14 } from '../data/topicai14';
import { topicai15 } from '../data/topicai15';
import { topicai16 } from '../data/topicai16';
import { topicai17 } from '../data/topicai17';
import { topicai18 } from '../data/topicai18';
import { topicai19 } from '../data/topicai19';
import { topicai20 } from '../data/topicai20';

const topics = [
  topicai1, topicai2, topicai3, topicai4, topicai5,
  topicai6, topicai7, topicai8, topicai9, topicai10,
  topicai11, topicai12, topicai13, topicai14, topicai15,
  topicai16, topicai17, topicai18, topicai19, topicai20
];

const COURSE_ID = 'ai-python';
const GROQ_API_KEY = process.env.REACT_APP_GROQ_API_KEY;

const NAV_ITEMS = [
  { id: 'content', icon: BookOpen, label: 'Məzmun', emoji: '📚' },
  { id: 'quiz', icon: PlayCircle, label: 'Quiz', emoji: '📝' },
  { id: 'practice', icon: Edit3, label: 'Məşq', emoji: '✏️' },
  { id: 'editor', icon: Code2, label: 'Editor', emoji: '💻' },
  { id: 'analysis', icon: BarChart3, label: 'Təhlil', emoji: '📊' },
  { id: 'videos', icon: Video, label: 'Video', emoji: '🎥' },
];

const aiVideoLinks = [
  { topicId: 1, title: "Python Dəyişənləri", duration: "15:30", url: "https://youtu.be/V1c0MzR8qo8?si=VTQFIcaakZHEgdCv" },
  { topicId: 1, title: "Python Məlumat Tipləri", duration: "12:45", url: "https://youtu.be/L2Ryd70pVXI?si=9iDC00hct2RHUxHM" },
  { topicId: 2, title: "Set ve Tuple", duration: "18:20", url: "https://youtu.be/OMwQ_i9GJbI?si=3UJH1fepGsU1bGvM" },
  { topicId: 2, title: "List", duration: "16:50", url: "https://youtu.be/pBMuc4cc_Ck?si=lgfUe58fWOXJFmAC" },
  { topicId: 2, title: "Dictionary", duration: "12:30", url: "https://youtu.be/0jKOxXn7yMg?si=z7Q8jpACJ1gf9BCN" },
  { topicId: 3, title: "Şərt Operatorları", duration: "14:15", url: "https://youtu.be/R6DmpXky2WA?si=bpTWg7WpUfkIPtbt" },
  { topicId: 3, title: "Şərt Operatorları : İç-içə Şərtlər", duration: "17:30", url: "https://youtu.be/gbNRVvPdSa0?si=UdQ6KZUWT-8OBh60" },
  { topicId: 4, title: "Dövrlər : For və While Dövrləri", duration: "19:45", url: "https://youtu.be/JUsemOXDvjY?si=axD0VxWozQFym2DK" },
  { topicId: 5, title: "Funksiyalar", duration: "22:10", url: "https://youtu.be/_HRn8zB47cs?si=oHTLBbs3EWrQ7_Uu" },
  { topicId: 5, title: "Lambda və Map Funksiyaları", duration: "13:40", url: "https://youtu.be/yC9DIGj_J5o?si=8N7R5Ae1pf_3edNH" },
  { topicId: 6, title: "Fayllarla İş", duration: "41:57", url: "https://youtu.be/hO7IRvi2nyw?si=nPBtv1w4hj7k3dcw" },
  { topicId: 7, title: "Xətaların İdarə Edilməsi", duration: "24:28", url: "https://youtu.be/iBYppSXFw0A?si=aAVb159nGgLy7CMj" },
];

// ============================================
// CHATBOT COMPONENT - MOBIL DÜZƏLİŞLİ
// ============================================

const Chatbot = ({ topic }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    { 
      role: 'assistant', 
      content: 'Salam! 👋 Mən Lumina AI Təhsil Platformasının Süni İntellekt Kurs Müəllimiyəm. Sizə Python, Data Science, Machine Learning və Deep Learning mövzularında tam dəstək verirəm. Sualınız varsa, buyurun soruşun!' 
    }
  ]);
  const [input, setInput] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages, isOpen]);

  // Mobil üçün input focus düzəlişi
  useEffect(() => {
    if (isOpen && inputRef.current) {
      // iOS və Android üçün virtual klaviatura düzəlişi
      setTimeout(() => {
        inputRef.current?.focus();
      }, 300);
    }
  }, [isOpen]);

  const sendMessage = async () => {
    if (!input.trim()) return;

    const userMessage = { role: 'user', content: input };
    setMessages(prev => [...prev, userMessage]);
    setInput('');
    setIsTyping(true);

    try {
      const response = await fetch('https://api.groq.com/openai/v1/chat/completions', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${GROQ_API_KEY}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          model: 'llama-3.3-70b-versatile',
          messages: [
            {
              role: 'system',
              content: `Sən Lumina Təhsil Platformasının AI Kurs Müəllimisisən. 
Python, Data Science, ML mövzularında kömək et. Azərbaycanca cavab ver.
${topic ? `Hazırda mövzu: ${topic.title}` : ''}`
            },
            ...messages.map(m => ({ role: m.role, content: m.content })),
            { role: 'user', content: input }
          ],
          temperature: 0.7,
          max_tokens: 2048
        })
      });

      const data = await response.json();
      const botResponse = data.choices[0].message.content;
      setMessages(prev => [...prev, { role: 'assistant', content: botResponse }]);
    } catch (error) {
      console.error('Chatbot error:', error);
      setMessages(prev => [...prev, { 
        role: 'assistant', 
        content: 'Bağışlayın, texniki problem yarandı. Zəhmət olmasa sonra yenidən cəhd edin.' 
      }]);
    } finally {
      setIsTyping(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  // Touch event handler for mobile
  const handleInputClick = (e) => {
    e.stopPropagation();
    inputRef.current?.focus();
  };

  return (
    <div className="chatbot-wrapper">
      <button
        onClick={() => setIsOpen(!isOpen)}
        onTouchStart={() => setIsOpen(!isOpen)}
        className={`chatbot-toggle ${isOpen ? 'open' : ''}`}
      >
        {isOpen ? <X size={24} /> : <Bot size={28} />}
      </button>

      {isOpen && (
        <div className="chatbot-window" onClick={(e) => e.stopPropagation()}>
          <div className="chatbot-header">
            <div className="chatbot-title">
              <div className="chatbot-avatar">
                <Brain size={20} />
              </div>
              <div className="chatbot-title-text">
                <h4>Lumina AI</h4>
                <span>🟢 Onlayn</span>
              </div>
            </div>
            <button 
              onClick={() => setIsOpen(false)} 
              onTouchStart={() => setIsOpen(false)}
              className="chatbot-close"
            >
              <X size={20} />
            </button>
          </div>

          <div className="chatbot-messages" onClick={(e) => e.stopPropagation()}>
            {messages.map((msg, idx) => (
              <div key={idx} className={`chat-message ${msg.role}`}>
                {msg.content}
              </div>
            ))}
            {isTyping && (
              <div className="typing-indicator">
                <span />
                <span />
                <span />
              </div>
            )}
            <div ref={messagesEndRef} />
          </div>

          <div className="chatbot-input-area" onClick={(e) => e.stopPropagation()}>
            <input
              ref={inputRef}
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyPress={handleKeyPress}
              onClick={handleInputClick}
              onTouchStart={handleInputClick}
              onFocus={(e) => {
                // Mobil klaviatura açılanda scroll düzəlişi
                setTimeout(() => {
                  messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
                }, 300);
              }}
              placeholder="Sualınızı yazın..."
              disabled={isTyping}
              className="chatbot-input"
              autoComplete="off"
              autoCorrect="off"
              autoCapitalize="off"
              spellCheck="false"
            />
            <button 
              onClick={sendMessage}
              onTouchStart={sendMessage}
              disabled={isTyping || !input.trim()}
              className="chatbot-send"
            >
              <Send size={18} />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

// ============================================
// CODING TASK COMPONENT
// ============================================

const CodingTask = ({ task, taskIndex, pyodideRef, pyodideReady, onSubmit }) => {
  const [code, setCode] = useState('');
  const [output, setOutput] = useState('');
  const [hasRun, setHasRun] = useState(false);
  const [isRunning, setIsRunning] = useState(false);

  const runPythonCode = async (codeToRun) => {
    if (!pyodideReady || !pyodideRef.current) {
      return { success: false, error: 'Python hazır deyil', output: '' };
    }
    try {
      await pyodideRef.current.runPythonAsync(`import sys, io\nsys.stdout = io.StringIO()`);
      await pyodideRef.current.runPythonAsync(codeToRun);
      const outputResult = pyodideRef.current.runPython("sys.stdout.getvalue()");
      return { success: true, output: outputResult, error: null };
    } catch (err) {
      return { success: false, error: err.message, output: '' };
    }
  };

  const handleRun = async () => {
    if (hasRun || !code.trim()) return;
    setIsRunning(true);
    const result = await runPythonCode(code);
    setOutput(result.error || result.output || 'Nəticə yoxdur');
    setHasRun(true);
    setIsRunning(false);
    
    setTimeout(() => {
      onSubmit(code, result.output || '', result.error || '', task);
    }, 1500);
  };

  if (!task) {
    return (
      <div className="loading-container">
        <Loader2 className="spin" size={32} />
        <p>Tapşırıq yüklənir...</p>
      </div>
    );
  }

  return (
    <div className="coding-task">
      <div className="task-card">
        <div className="task-header">
          <span className="task-badge">Tapşırıq {taskIndex + 1} / 2</span>
          <span className="task-points">20 bal</span>
        </div>
        
        <h3 className="task-title">{task.title || 'Tapşırıq'}</h3>
        <p className="task-description">{task.description || ''}</p>
        
        {task.requirements && task.requirements.length > 0 && (
          <div className="requirements-box">
            <h4>📝 Tələblər:</h4>
            <ul>
              {task.requirements.map((req, i) => <li key={i}>{req}</li>)}
            </ul>
          </div>
        )}

        {task.concepts && (
          <div className="concepts-box">
            <strong>💡 Bu tapşırıq bunları əhatə edir:</strong>
            <p>{task.concepts}</p>
          </div>
        )}
      </div>

      <div className="code-editor-container">
        <div className="editor-toolbar">
          <span className="editor-label">🐍 Python Editor</span>
          <button
            onClick={handleRun}
            disabled={isRunning || !pyodideReady || hasRun || !code.trim()}
            className={`run-button ${hasRun ? 'completed' : ''}`}
          >
            {isRunning ? <Loader2 className="spin" size={14} /> : hasRun ? <CheckCircle2 size={14} /> : <Play size={14} />}
            {isRunning ? 'İcra edilir...' : hasRun ? 'Tamamlandı' : 'Run'}
          </button>
        </div>
        
        <div className="editor-wrapper">
          <textarea
            value={code}
            onChange={(e) => !hasRun && setCode(e.target.value)}
            placeholder="# Kodunuzu bura yazın..."
            disabled={hasRun}
            className="code-textarea"
          />
          {output && (
            <div className={`output-panel ${output.includes('Error') || output.includes('xəta') ? 'error' : 'success'}`}>
              <div className="output-label">Output</div>
              {output}
            </div>
          )}
        </div>
      </div>

      {hasRun && (
        <div className="success-message">
          <CheckCircle2 size={20} />
          <p>Kod göndərildi. Növbəti tapşırığa keçilir...</p>
        </div>
      )}
    </div>
  );
};

// ============================================
// PRACTICE COMPONENT
// ============================================

const PracticeSection = ({ topic, user, userName, topicId }) => {
  const [showEditor, setShowEditor] = useState(false);

  if (!topic || !topic.exercise) {
    return (
      <div className="empty-state">
        <AlertCircle size={48} />
        <h3>Bu mövzu üçün praktik tapşırıq yoxdur</h3>
      </div>
    );
  }

  return (
    <div className="practice-section">
      <div className="info-banner practice">
        <div className="info-banner-header">
          <Target size={24} />
          <h3>Məşq Bölməsi</h3>
        </div>
        <p>Buradakı tapşırığı köməksiz özünüz həll edərək mövzunu tam mənimsədiyinizi sübut edin. 
          Əgər çətinlik çəksəniz, əvvəlki səhifələrə qayıdıb mövzunu yenidən oxuya bilərsiniz.</p>
      </div>

      <div className="exercise-card">
        <h4>{topic.exercise.title || 'Məşq'}</h4>
        <p>{topic.exercise.description || ''}</p>
        
        {topic.exercise.requirements && topic.exercise.requirements.length > 0 && (
          <div className="requirements-list">
            <strong>Tələblər:</strong>
            <ul>
              {topic.exercise.requirements.map((req, i) => <li key={i}>{req}</li>)}
            </ul>
          </div>
        )}

        <button
          onClick={() => setShowEditor(!showEditor)}
          className="toggle-editor-btn"
        >
          <Edit3 size={16} />
          {showEditor ? 'Editor-u Gizlət' : 'Editor-da Aç'}
        </button>
      </div>

      {showEditor && (
        <div className="editor-container">
          <Editor 
            mode="exercise"
            starterCode={topic.exercise.starterCode || '# Kodunuzu bura yazın'}
            userId={user?.uid}
            userName={userName}
            courseId={COURSE_ID}
            topicId={topicId}
          />
        </div>
      )}
    </div>
  );
};

// ============================================
// TOPIC ASSESSMENT COMPONENT - TƏHLİLƏ YÖNLƏNDİRMƏLİ
// ============================================

const TopicAssessment = ({ topic, topicIndex, user, userName, onComplete, setActiveTab }) => {
  const [assessmentState, setAssessmentState] = useState('intro');
  const [quizData, setQuizData] = useState(null);
  const [quizAnswers, setQuizAnswers] = useState({});
  const [quizResults, setQuizResults] = useState(null);
  const [codingTasks, setCodingTasks] = useState(null);
  const [currentCodingIndex, setCurrentCodingIndex] = useState(0);
  const [codingSubmissions, setCodingSubmissions] = useState([]);
  const [analysisResult, setAnalysisResult] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const pyodideRef = useRef(null);
  const [pyodideReady, setPyodideReady] = useState(false);

  useEffect(() => {
    const initPyodide = async () => {
      if (!window.loadPyodide) {
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/pyodide/v0.24.1/full/pyodide.js';
        script.async = true;
        document.head.appendChild(script);
        await new Promise((res, rej) => {
          script.onload = res;
          script.onerror = () => rej(new Error('Pyodide yüklənmədi'));
        });
      }
      try {
        pyodideRef.current = await window.loadPyodide();
        await pyodideRef.current.loadPackage("micropip");
        setPyodideReady(true);
      } catch (err) {
        console.error('Pyodide init error:', err);
      }
    };
    initPyodide();
  }, []);

  useEffect(() => {
    if (quizData && codingTasks && isLoading) {
      setAssessmentState('quiz');
      setIsLoading(false);
    }
  }, [quizData, codingTasks, isLoading]);

const generateQuiz = async () => {
  setIsLoading(true);
  setQuizData(null);
  setCodingTasks(null);
  
  try {
    const [quizResponse, tasksResponse] = await Promise.all([
      fetch('https://api.groq.com/openai/v1/chat/completions', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${GROQ_API_KEY}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          model: 'llama-3.3-70b-versatile',
          messages: [
            {
              role: 'system',
              content: `Sən Python təhsil müəllimisisən. Aşağıdakı mövzu üçün 15 suallıq test yaradırsan.
              
TƏLƏBLƏR:
1. HƏR BİR 15 SUAL TAMAMİLƏ FƏRQLİ OLMALIDIR - heç bir sual digərinə oxşamamalıdır, her movzuya uygun sirf hemin movzuda suallar olmalidir.
2. Sual 1-5: Əsas anlayışlar (dəyişənlər, tiplər, sintaksis)
3. Sual 6-10: Praktiki tətbiq (kod analizi, çıxış proqnozu, kod səhvləri)
4. Sual 11-15: Mürəkkəb məsələlər (algoritm, məntiq, xətaların düzəldilməsi)
5. Hər sualın 4 variantı olsun, yalnız biri düzgün
6. Düzgün cavablar bərabər paylanmalıdır (A, B, C, D)
7. Sual mətnləri konkret və aydın olmalıdır
8. JSON formatında cavab ver

CAVAB FORMATI:
{
  "questions": [
    {
      "question": "sual mətni",
      "options": ["variant A", "variant B", "variant C", "variant D"],
      "correctAnswer": 0,
      "explanation": "izahat"
    }
  ]
}`
            },
            {
              role: 'user',
              content: `Mövzu: ${topic?.title || 'Python'}\n\nMövzu məzmunu: ${topic?.content?.substring(0, 3000) || ''}\n\n15 tamamilə fərqli sual hazırla. Təkrarlanan suallar olmamalıdır.`
            }
          ],
          temperature: 0.3,
          max_tokens: 4000,
          response_format: { type: "json_object" }
        })
      }),
      fetch('https://api.groq.com/openai/v1/chat/completions', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${GROQ_API_KEY}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          model: 'llama-3.3-70b-versatile',
          messages: [
            {
              role: 'system',
              content: `Sən Python təhsil müəllimisisən. Aşağıdakı mövzu üçün 2 sadə praktik kod tapşırığı yaradırsan.

TƏLƏBLƏR:
1. Tapşırıqlar mövzuya uyğun olmalıdır
2. Hər tapşırıq başlanğıc səviyyədə olsun (15-20 sətir kod)
3. Real həyatdan nümunələr olsun (hesablama, məlumat emalı, sadə algoritm)
4. Tələblər aydın və konkret olsun
5. JSON formatında cavab ver

CAVAB FORMATI:
{
  "tasks": [
    {
      "id": 1,
      "title": "tapşırıq adı",
      "description": "ətraflı izahat",
      "requirements": ["tələb 1", "tələb 2"],
      "concepts": "istifadə olunan konseptlər",
      "starterCode": "# başlanğıc kod (əgər lazımdırsa)"
    },
    {
      "id": 2,
      "title": "tapşırıq adı",
      "description": "ətraflı izahat",
      "requirements": ["tələb 1", "tələb 2"],
      "concepts": "istifadə olunan konseptlər",
      "starterCode": "# başlanğıc kod (əgər lazımdırsa)"
    }
  ]
}`
            },
            {
              role: 'user',
              content: `Mövzu: ${topic?.title || 'Python'}\n\n2 sadə praktik kod tapşırığı yarat. Mövzu: ${topic?.content?.substring(0, 2000) || ''}`
            }
          ],
          temperature: 0.3,
          max_tokens: 2000,
          response_format: { type: "json_object" }
        })
      })
    ]);

    if (!quizResponse.ok) {
      const errorText = await quizResponse.text();
      throw new Error(`Quiz API error: ${quizResponse.status} - ${errorText}`);
    }
    
    if (!tasksResponse.ok) {
      const errorText = await tasksResponse.text();
      throw new Error(`Tasks API error: ${tasksResponse.status} - ${errorText}`);
    }

    const quizDataRaw = await quizResponse.json();
    let quizContent;
    try {
      quizContent = JSON.parse(quizDataRaw.choices[0].message.content);
    } catch (e) {
      console.error('Quiz JSON parse error:', e);
      throw new Error('Quiz formatı yanlışdır');
    }
    
    if (!quizContent.questions || !Array.isArray(quizContent.questions)) {
      throw new Error('Quiz formatı yanlışdır');
    }

    let finalQuestions = quizContent.questions.slice(0, 15);
    if (finalQuestions.length < 15) {
      console.warn(`Yalnız ${finalQuestions.length} sual gəldi, 15 gözlənilirdi. Fallback əlavə edilir.`);
      while (finalQuestions.length < 15) {
        finalQuestions.push({
          question: `${topic?.title || 'Bu mövzu'} haqqında əlavə sual ${finalQuestions.length + 1}?`,
          options: ['Doğru cavab', 'Yanlış cavab 1', 'Yanlış cavab 2', 'Yanlış cavab 3'],
          correctAnswer: 0,
          explanation: 'Bu mövzunun əsas anlayışı.'
        });
      }
    }
    
    setQuizData(finalQuestions);

    const tasksDataRaw = await tasksResponse.json();
    let tasksContent;
    try {
      tasksContent = JSON.parse(tasksDataRaw.choices[0].message.content);
    } catch (e) {
      console.error('Tasks JSON parse error:', e);
      throw new Error('Tasks formatı yanlışdır');
    }
    
    if (!tasksContent.tasks || !Array.isArray(tasksContent.tasks)) {
      throw new Error('Tasks formatı yanlışdır');
    }

    const tasks = tasksContent.tasks.slice(0, 2);
    while (tasks.length < 2) {
      tasks.push({
        id: tasks.length + 1,
        title: `Tapşırıq ${tasks.length + 1}`,
        description: 'Sadə Python kodu yazın',
        requirements: ['Kod yazın', 'Run düyməsinə basın'],
        concepts: 'əsas sintaksis'
      });
    }
    
    setCodingTasks(tasks);
    
    setAssessmentState('quiz');
    setIsLoading(false);
    
  } catch (error) {
    console.error('Generation error:', error);
    
    let errorMessage = 'Quiz yaradılarkən xəta baş verdi.';
    if (error.message.includes('401')) {
      errorMessage = 'API açarı yanlışdır. Zəhmət olmasa .env faylını yoxlayın.';
    } else if (error.message.includes('429')) {
      errorMessage = 'Həddindən artıq sorğu. Zəhmət olmasa 1 dəqiqə gözləyin.';
    } else if (error.message.includes('500')) {
      errorMessage = 'Groq server xətası. Zəhmət olmasa sonra yenidən cəhd edin.';
    }
    
    alert(errorMessage);
    
    setQuizData([
      {
        question: `${topic?.title || 'Bu mövzu'} haqqında əsas anlayış nədir?`,
        options: ['Doğru cavab', 'Yanlış cavab 1', 'Yanlış cavab 2', 'Yanlış cavab 3'],
        correctAnswer: 0,
        explanation: 'Bu mövzunun əsas anlayışı.'
      }
    ]);
    setCodingTasks([
      {
        id: 1,
        title: 'Salam Dünya',
        description: 'Konsola "Salam Dünya" yazdırın',
        requirements: ['print funksiyasından istifadə edin'],
        concepts: 'print funksiyası, string'
      },
      {
        id: 2,
        title: 'Dəyişənlər',
        description: 'Bir dəyişən yaradın və onu çap edin',
        requirements: ['Dəyişən təyin edin', 'print ilə çap edin'],
        concepts: 'dəyişənlər, mənimsətmə'
      }
    ]);
    
    setAssessmentState('quiz');
    setIsLoading(false);
  }
};

  const saveWrongQuizToFirebase = async (quizItem, userAnswer, topicId, topicTitle) => {
    if (!user) return;
    try {
      await addDoc(collection(db, 'quizTest'), {
        userName, 
        userId: user.uid, 
        topicId, 
        topicTitle,
        quizQuestion: quizItem.question, 
        quizOptions: quizItem.options,
        correctAnswer: quizItem.options?.[quizItem.correctAnswer], 
        userAnswer,
        explanation: quizItem.explanation, 
        timestamp: serverTimestamp(), 
        courseId: COURSE_ID
      });
    } catch (err) {
      console.error('Quiz save error:', err);
    }
  };

  const saveWrongCodeToFirebase = async (task, code, error, output, topicId, topicTitle) => {
    if (!user) return;
    try {
      await addDoc(collection(db, 'kodTest'), {
        userName, 
        userId: user.uid, 
        topicId, 
        topicTitle,
        taskTitle: task?.title, 
        taskDescription: task?.description,
        taskRequirements: task?.requirements, 
        userCode: code,
        errorMessage: error, 
        output, 
        timestamp: serverTimestamp(), 
        courseId: COURSE_ID
      });
    } catch (err) {
      console.error('Code save error:', err);
    }
  };

  const submitQuiz = async () => {
    if (!quizData || !Array.isArray(quizData) || quizData.length === 0) {
      alert('Quiz məlumatları yüklənməyib.');
      return;
    }

    if (Object.keys(quizAnswers).length < quizData.length) {
      alert(`Zəhmət olmasa bütün sualları cavablandırın! (${Object.keys(quizAnswers).length}/${quizData.length})`);
      return;
    }

    let correct = 0;
    const results = [];
    const wrongQuizzes = [];

    for (let idx = 0; idx < quizData.length; idx++) {
      const q = quizData[idx];
      if (!q || !q.options) continue;
      
      const isCorrect = quizAnswers[idx] === q.correctAnswer;
      const userAnswerText = q.options[quizAnswers[idx]] || 'Cavab verilməyib';
      
      if (isCorrect) {
        correct++;
      } else {
        await saveWrongQuizToFirebase(q, userAnswerText, topicIndex + 1, topic?.title);
        wrongQuizzes.push({
          question: q.question, 
          userAnswer: userAnswerText,
          correctAnswer: q.options[q.correctAnswer], 
          explanation: q.explanation
        });
      }
      
      results.push({
        question: q.question, 
        userAnswer: userAnswerText,
        correctAnswer: q.options[q.correctAnswer], 
        isCorrect, 
        explanation: q.explanation
      });
    }

    const totalQuestions = quizData.length;
    const quizScore = totalQuestions > 0 ? (correct / totalQuestions) * 60 : 0;

    setQuizResults({
      correct, 
      total: totalQuestions, 
      score: quizScore,
      details: results, 
      wrongQuizzes
    });

    setCurrentCodingIndex(0);
    setAssessmentState('coding1');
  };

  const submitCodingTask = async (code, output, error, task) => {
    const hasError = !!error || !code.trim();
    
    if (hasError) {
      await saveWrongCodeToFirebase(task, code, error || 'Kod xəta verdi', output, topicIndex + 1, topic?.title);
    }

    const submission = {
      taskId: task?.id, 
      title: task?.title, 
      description: task?.description,
      code, 
      output, 
      error: error || '', 
      passed: !hasError,
      timestamp: new Date().toISOString()
    };

    const newSubmissions = [...codingSubmissions, submission];
    setCodingSubmissions(newSubmissions);

    if (currentCodingIndex === 0) {
      setTimeout(() => {
        setCurrentCodingIndex(1);
        setAssessmentState('coding2');
      }, 1000);
    } else {
      setTimeout(async () => {
        await analyzeResults(newSubmissions);
      }, 1000);
    }
  };

  // DƏYİŞİKLİK: Detallı və sadə AI analizi
  const analyzeResults = async (finalCodingSubmissions) => {
    setAssessmentState('analyzing');
    setIsLoading(true);

    try {
      const quizQuery = query(collection(db, 'quizTest'), where('userName', '==', userName), where('topicId', '==', topicIndex + 1));
      const quizSnapshot = await getDocs(quizQuery);
      const wrongQuizzesFromDB = quizSnapshot.docs.map(doc => doc.data());

      const kodQuery = query(collection(db, 'kodTest'), where('userName', '==', userName), where('topicId', '==', topicIndex + 1));
      const kodSnapshot = await getDocs(kodQuery);
      const wrongCodesFromDB = kodSnapshot.docs.map(doc => doc.data());

      const quizScore = quizResults?.score || 0;
      const codingPassed = finalCodingSubmissions.filter(c => c.passed).length;
      const codingScore = codingPassed * 20;
      const totalScore = quizScore + codingScore;
      const masteryPercentage = Math.round(Math.min(totalScore, 100));

      let masteryLevel = '';
      let masteryColor = '';
      if (masteryPercentage >= 90) {
        masteryLevel = 'Tam Mənimsəmiş'; 
        masteryColor = '#48bb78';
      } else if (masteryPercentage >= 60) {
        masteryLevel = 'Orta Mənimsəmiş'; 
        masteryColor = '#ed8936';
      } else if (masteryPercentage >= 30) {
        masteryLevel = 'Zəif Mənimsəmiş'; 
        masteryColor = '#ecc94b';
      } else {
        masteryLevel = 'Mənimsəməmiş'; 
        masteryColor = '#f56565';
      }

      // DƏYİŞİKLİK: Daha detallı və incəliklərə toxunan prompt
      const promptForAI = `Sən Python təhsil mentorusan. Tələbənin nəticələrini təhlil et və konkret, praktiki tövsiyələr ver.

## MÖVZU: ${topic?.title || 'Python'}
## ÜMUMİ NƏTİCƏ: ${masteryPercentage}% - ${masteryLevel}

### QUIZ NƏTİCƏLƏRİ:
- Doğru cavablar: ${quizResults?.correct || 0}/${quizResults?.total || 0}
- Xal: ${quizScore}/60

### KOD TAPŞIRIQLARI:
- Uğurlu: ${codingPassed}/2
- Xal: ${codingScore}/40

### SƏHV EDİLƏN QUIZLƏR:
${wrongQuizzesFromDB.length > 0 ? wrongQuizzesFromDB.map((q, i) => `
${i+1}. Sual: ${q.quizQuestion}
   Sənin cavabın: ${q.userAnswer}
   Doğru cavab: ${q.correctAnswer}
   Səbəb: ${q.explanation || 'Mövzu tam mənimsənilməyib'}`
).join('\n') : 'Quizdə səhv yoxdur.'}

### KOD XƏTALARI:
${wrongCodesFromDB.length > 0 ? wrongCodesFromDB.map((k, i) => `
${i+1}. Tapşırıq: ${k.taskTitle}
   Yazdığın kod: ${k.userCode?.substring(0, 100)}...
   Xəta: ${k.errorMessage || 'Sintaksis və ya məntiq xətası'}
   Gözlənilən: ${k.taskRequirements?.join(', ')}`
).join('\n') : 'Kod tapşırıqlarında xəta yoxdur.'}

## TƏLƏBLƏR:
1. Hər bir səhv üçün konkret izah ver - niyə səhv olduğunu sadə dildə izah et
2. Hansı mövzuları təkrar oxumalı olduğunu dəqiq göstər
3. Praktiki məşğələlər təklif et (real kod nümunələri)
4. Ümumi inkişaf planı ver (növbəti addımlar)
5. MÜTLƏQ AZƏRBAYCAN dilində cavab ver
6. Sadə, tələbə dostu dil istifadə et
7. Hər şeyi maddələr halında yaz

Cavab formatı:
📊 ÜMUMİ QİYMƏTLƏNDİRMƏ: [qısa təhlil]

🔍 DETALLI TƏHLIL:
- [hər səhv üçün ayrıca izah]

📚 TƏKRARLANMALI MÖVZULAR:
1. [mövzu adı] - səbəb: [qısa izah]

💻 PRAKTİK TÖVSİYƏLƏR:
- [konkret məşğələlər]

🎯 NÖVBƏTİ ADDIMLAR:
1. [addım]`;

      const response = await fetch('https://api.groq.com/openai/v1/chat/completions', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${GROQ_API_KEY}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          model: 'llama-3.3-70b-versatile',
          messages: [
            { role: 'system', content: 'Sən Python təhsil mentorusan. Azərbaycanca, sadə və anlaşıqlı cavab ver.' },
            { role: 'user', content: promptForAI }
          ],
          temperature: 0.4, // Daha dəqiq cavablar üçün aşağı temperature
          max_tokens: 3000 // Daha uzun, detallı cavab üçün
        })
      });

      const data = await response.json();
      const aiAnalysis = data.choices[0]?.message?.content || 'Təhlil mövcud deyil.';

      const finalResult = {
        topicId: topicIndex + 1, 
        topicTitle: topic?.title || 'Mövzu',
        quizScore, 
        quizCorrect: quizResults?.correct || 0, 
        quizTotal: quizResults?.total || 0,
        codingScore, 
        codingPassed, 
        codingTotal: 2,
        totalScore, 
        masteryPercentage, 
        masteryLevel, 
        masteryColor,
        aiAnalysis, 
        wrongQuizzes: wrongQuizzesFromDB, 
        wrongCodes: wrongCodesFromDB,
        completedAt: serverTimestamp(), 
        userName, 
        userId: user?.uid
      };

      setAnalysisResult(finalResult);
      setAssessmentState('result');

      const docId = `${userName}_topic${topicIndex + 1}`;
      await setDoc(doc(db, 'topicAssessments', docId), finalResult);

      if (onComplete) onComplete(finalResult);

    } catch (error) {
      console.error('Analysis error:', error);
      alert('Analiz zamanı xəta baş verdi.');
    } finally {
      setIsLoading(false);
    }
  };

  const renderIntro = () => (
    <div className="assessment-intro">
      <div className="intro-icon">🎯</div>
      <h2>{topic?.title || 'Mövzu'}</h2>
      <p>15 suallıq dəqiq quiz və 2 sadə kod tapşırığı</p>
      <div className="intro-stats">
        <div className="stat-box">
          <div className="stat-number">15</div>
          <div className="stat-label">Quiz (60%)</div>
        </div>
        <div className="stat-box">
          <div className="stat-number">2</div>
          <div className="stat-label">Kod (40%)</div>
        </div>
      </div>
      <button
        onClick={generateQuiz}
        disabled={isLoading}
        className="start-assessment-btn"
      >
        {isLoading ? <><Loader2 className="spin" size={20} /> Hazırlanır...</> : <><Target size={20} /> Özünü Yoxla</>}
      </button>
    </div>
  );

  const renderQuiz = () => {
    if (!quizData || !Array.isArray(quizData) || quizData.length === 0) {
      return (
        <div className="loading-container">
          <Loader2 className="spin" size={32} />
          <p>Quiz yüklənir...</p>
          <button onClick={() => setAssessmentState('intro')} className="back-btn">
            Geri Qayıt
          </button>
        </div>
      );
    }

    return (
      <div className="quiz-container">
        <div className="info-banner quiz">
          <p>📚 <strong>Bilik Yoxlama:</strong> Burada öyrəndiklərinizi yoxlaya bilərsiniz. 
            {quizData.length} sualdan ibarət quiz mövzunun əsas anlayışlarını yoxlayır.</p>
        </div>

        <div className="quiz-progress">
          <h3>📝 Quiz: {topic?.title || 'Mövzu'}</h3>
          <div className="progress-count">{Object.keys(quizAnswers).length} / {quizData.length}</div>
        </div>

        <div className="questions-list">
          {quizData.map((q, idx) => {
            if (!q || !q.options || !Array.isArray(q.options)) return null;

            return (
              <div key={idx} className={`quiz-question-card ${quizAnswers[idx] !== undefined ? 'answered' : ''}`}>
                <div className="question-header">
                  <span className="question-number">{idx + 1}</span>
                  <p className="question-text">{q.question || 'Sual'}</p>
                </div>
                
                <div className="options-list">
                  {q.options.map((opt, optIdx) => (
                    <label key={optIdx} className={`option-label ${quizAnswers[idx] === optIdx ? 'selected' : ''}`}>
                      <input
                        type="radio"
                        name={`question-${idx}`}
                        checked={quizAnswers[idx] === optIdx}
                        onChange={() => setQuizAnswers({ ...quizAnswers, [idx]: optIdx })}
                        className="option-input"
                      />
                      <span className="option-radio" />
                      <span className="option-text">{opt}</span>
                    </label>
                  ))}
                </div>
              </div>
            );
          })}
        </div>

        <button onClick={submitQuiz} className="submit-quiz-btn">
          Quiz-i Təsdiqlə →
        </button>
      </div>
    );
  };

  const renderAnalyzing = () => (
    <div className="analyzing-state">
      <div className="spinner-large" />
      <h3>AI Təhlil Edir...</h3>
      <p>Səhv quizlər və kodlar təhlil edilir</p>
    </div>
  );

  // DƏYİŞİKLİK: Nəticə ekranında Təhlil bölməsinə keçid
  const renderResult = () => {
    if (!analysisResult) {
      return (
        <div className="loading-container">
          <p>Nəticə yüklənir...</p>
        </div>
      );
    }

    return (
      <div className="result-container">
        <div className="result-header" style={{ background: analysisResult.masteryColor }}>
          <Trophy size={48} />
          <h2>{analysisResult.masteryLevel}</h2>
          <p>{analysisResult.topicTitle}</p>
        </div>

        <div className="result-stats">
          <div className="result-stat-box">
            <div className="result-stat-value" style={{ color: analysisResult.masteryColor }}>{analysisResult.masteryPercentage}%</div>
            <div className="result-stat-label">Mənimsəmə</div>
          </div>
          <div className="result-stat-box">
            <div className="result-stat-value success">{analysisResult.quizCorrect}/{analysisResult.quizTotal}</div>
            <div className="result-stat-label">Quiz</div>
          </div>
          <div className="result-stat-box">
            <div className="result-stat-value warning">{analysisResult.codingPassed}/{analysisResult.codingTotal}</div>
            <div className="result-stat-label">Kod</div>
          </div>
        </div>

        <div className="ai-analysis-box">
          <h4><Brain size={20} /> 🤖 AI Mentor Təhlili</h4>
          <div className="ai-analysis-content">{analysisResult.aiAnalysis}</div>
        </div>

        <div className="result-actions">
          <button
            onClick={() => {
              setAssessmentState('intro');
              setQuizData(null);
              setQuizAnswers({});
              setQuizResults(null);
              setCodingTasks(null);
              setCurrentCodingIndex(0);
              setCodingSubmissions([]);
              setAnalysisResult(null);
            }}
            className="retry-btn"
          >
            <RefreshCw size={18} /> Yenidən
          </button>
          {/* DƏYİŞİKLİK: Təhlil bölməsinə keçid düyməsi */}
          <button 
            onClick={() => {
              if (setActiveTab) {
                setActiveTab('analysis');
              }
            }} 
            className="complete-btn"
            style={{ background: '#4CAF50', marginLeft: '10px' }}
          >
            <BarChart3 size={18} /> Təhlilə Bax
          </button>
        </div>
      </div>
    );
  };

  return (
    <div className="topic-assessment">
      {assessmentState === 'intro' && renderIntro()}
      {assessmentState === 'quiz' && renderQuiz()}
      {assessmentState === 'coding1' && codingTasks && codingTasks.length > 0 && (
        <CodingTask 
          task={codingTasks[0]} 
          taskIndex={0} 
          pyodideRef={pyodideRef} 
          pyodideReady={pyodideReady} 
          onSubmit={submitCodingTask} 
        />
      )}
      {assessmentState === 'coding2' && codingTasks && codingTasks.length > 1 && (
        <CodingTask 
          task={codingTasks[1]} 
          taskIndex={1} 
          pyodideRef={pyodideRef} 
          pyodideReady={pyodideReady} 
          onSubmit={submitCodingTask} 
        />
      )}
      {assessmentState === 'analyzing' && renderAnalyzing()}
      {assessmentState === 'result' && renderResult()}
    </div>
  );
};

// ============================================
// ANALYSIS DASHBOARD COMPONENT - DETALLI VERSIYA
// ============================================

const AnalysisDashboard = ({ userName }) => {
  const [assessments, setAssessments] = useState([]);
  const [selectedAssessment, setSelectedAssessment] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadAssessments = async () => {
      if (!userName) {
        setLoading(false);
        return;
      }
      try {
        const q = query(collection(db, 'topicAssessments'), where('userName', '==', userName));
        const snapshot = await getDocs(q);
        const data = snapshot.docs.map(doc => doc.data());
        setAssessments(data.sort((a, b) => (a.topicId || 0) - (b.topicId || 0)));
      } catch (err) {
        console.error('Load error:', err);
      } finally {
        setLoading(false);
      }
    };
    loadAssessments();
  }, [userName]);

  if (loading) return <div className="loading-container">Yüklənir...</div>;

  const averageMastery = assessments.length > 0
    ? Math.round(assessments.reduce((acc, curr) => acc + (curr.masteryPercentage || 0), 0) / assessments.length)
    : 0;

  const getMasteryLevel = (pct) => {
    if (pct >= 90) return { level: 'Tam', color: '#48bb78' };
    if (pct >= 60) return { level: 'Orta', color: '#ed8936' };
    if (pct >= 30) return { level: 'Zəif', color: '#ecc94b' };
    return { level: 'Mənimsəməmiş', color: '#f56565' };
  };

  // DƏYİŞİKLİK: Detallı analiz paneli
  return (
    <div className="analysis-dashboard">
      <div className="analysis-header">
        <h2>📊 Ümumi Təhlil</h2>
        <div className="stats-row">
          <div className="stat-item">
            <h3>{averageMastery}%</h3>
            <p>Ortalama</p>
          </div>
          <div className="stat-item">
            <h3>{assessments.length}</h3>
            <p>Tamamlanan</p>
          </div>
        </div>
      </div>

      <div className="assessment-list">
        {assessments.map((assessment) => {
          const mastery = getMasteryLevel(assessment.masteryPercentage || 0);
          const isSelected = selectedAssessment?.topicId === assessment.topicId;
          return (
            <div 
              key={assessment.topicId || Math.random()} 
              className={`assessment-card ${isSelected ? 'active' : ''}`}
              onClick={() => setSelectedAssessment(isSelected ? null : assessment)}
            >
              <div className="assessment-header">
                <div>
                  <h4 className="assessment-title">Mövzu {assessment.topicId || '?'}: {assessment.topicTitle || 'Naməlum'}</h4>
                  <div className="mastery-badge" style={{ color: mastery.color }}>{assessment.masteryLevel || 'Naməlum'}</div>
                </div>
                <div className="assessment-percentage" style={{ color: mastery.color }}>{assessment.masteryPercentage || 0}%</div>
              </div>

              {isSelected && (
                <div className="ai-analysis-panel">
                  <div className="analysis-summary">
                    <div className="summary-item">
                      <span>📝 Quiz:</span>
                      <strong>{assessment.quizCorrect || 0}/{assessment.quizTotal || 0} doğru</strong>
                    </div>
                    <div className="summary-item">
                      <span>💻 Kod:</span>
                      <strong>{assessment.codingPassed || 0}/{assessment.codingTotal || 0} uğurlu</strong>
                    </div>
                    <div className="summary-item">
                      <span>📅 Tarix:</span>
                      <strong>{assessment.completedAt?.toDate ? new Date(assessment.completedAt.toDate()).toLocaleDateString('az-AZ') : 'Naməlum'}</strong>
                    </div>
                  </div>
                  
                  <div className="ai-detailed-analysis">
                    <h4><Brain size={16} /> 🤖 AI Mentor Detallı Təhlili</h4>
                    <div className="ai-analysis-content" style={{ whiteSpace: 'pre-wrap', lineHeight: '1.6' }}>
                      {assessment.aiAnalysis || 'Təhlil mövcud deyil.'}
                    </div>
                  </div>

                  {/* Səhv quizlər siyahısı */}
                  {assessment.wrongQuizzes && assessment.wrongQuizzes.length > 0 && (
                    <div className="wrong-questions-section">
                      <h5>❌ Səhv Cavablanan Suallar ({assessment.wrongQuizzes.length})</h5>
                      {assessment.wrongQuizzes.map((q, idx) => (
                        <div key={idx} className="wrong-item">
                          <p><strong>Sual:</strong> {q.quizQuestion}</p>
                          <p><strong>Sənin cavabın:</strong> <span style={{color: '#e53e3e'}}>{q.userAnswer}</span></p>
                          <p><strong>Doğru cavab:</strong> <span style={{color: '#38a169'}}>{q.correctAnswer}</span></p>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Səhv kodlar siyahısı */}
                  {assessment.wrongCodes && assessment.wrongCodes.length > 0 && (
                    <div className="wrong-code-section">
                      <h5>❌ Xəta Verən Kodlar ({assessment.wrongCodes.length})</h5>
                      {assessment.wrongCodes.map((k, idx) => (
                        <div key={idx} className="wrong-item">
                          <p><strong>Tapşırıq:</strong> {k.taskTitle}</p>
                          <p><strong>Xəta:</strong> <span style={{color: '#e53e3e'}}>{k.errorMessage || 'Sintaksis xətası'}</span></p>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}

        {assessments.length === 0 && (
          <div className="empty-state">
            <AlertCircle size={48} />
            <p>Hələ heç bir mövzu tamamlanmayıb.</p>
            <p className="hint">Mövzuları oxuyub "Özünü Yoxla" düyməsinə basaraq başlayın.</p>
          </div>
        )}
      </div>
    </div>
  );
};

// ============================================
// VIDEO SECTION COMPONENT
// ============================================

const VideoSection = ({ topicId }) => {
  const topicVideos = aiVideoLinks.filter(video => video.topicId === topicId);

  const handleWatchClick = (videoUrl) => {
    const cleanUrl = videoUrl?.trim();
    if (cleanUrl) {
      window.open(cleanUrl, '_blank', 'noopener,noreferrer');
    } else {
      alert('Bu video tezliklə əlavə olunacaq!');
    }
  };

  return (
    <div className="video-section">
      <div className="info-banner video">
        <div className="info-banner-header">
          <Video size={24} />
          <h3>Video Dəstəyi</h3>
        </div>
        <p>Burada mövzular haqqında əlavə dəstək material kimi uyğun YouTube linkləri qoyulub.</p>
      </div>

      {topicVideos.length === 0 ? (
        <div className="empty-state">
          <Video size={48} />
          <p>Bu mövzu üçün hələ video əlavə edilməyib.</p>
        </div>
      ) : (
        <div className="video-grid">
          {topicVideos.map((video, index) => {
            const hasUrl = video.url && video.url.trim() !== '';
            return (
              <div key={index} className="video-card">
                <div className={`video-thumbnail ${!hasUrl ? 'locked' : ''}`}>
                  {hasUrl ? <Play size={24} fill="currentColor" /> : <Lock size={24} />}
                </div>
                <div className="video-info">
                  <h4>{video.title}</h4>
                  <span className="video-duration">⏱️ {video.duration}</span>
                </div>
                <button
                  onClick={() => handleWatchClick(video.url)}
                  disabled={!hasUrl}
                  className="watch-btn"
                >
                  <ExternalLink size={16} />
                  {hasUrl ? 'YouTube-da Aç' : 'Tezliklə'}
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

// ============================================
// MAIN AI COMPONENT
// ============================================

const AI = () => {
  const [currentTopic, setCurrentTopic] = useState(0);
  const [accessCode, setAccessCode] = useState('');
  const [isActivated, setIsActivated] = useState(false);
  const [activeTab, setActiveTab] = useState('content');
  const [user, setUser] = useState(null);
  const [activationData, setActivationData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activationError, setActivationError] = useState('');
  const [currentMonth, setCurrentMonth] = useState(0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [topicResults, setTopicResults] = useState({});
  // YENI: Aktivləşdirmə modalı state
  const [showActivationModal, setShowActivationModal] = useState(false);
  const activationInputRef = useRef(null);

  const getUserName = (firebaseUser) => {
    if (!firebaseUser) return 'guest';
    if (firebaseUser.displayName) {
      return firebaseUser.displayName.toLowerCase().replace(/\s+/g, '');
    }
    if (firebaseUser.email) {
      return firebaseUser.email.split('@')[0].toLowerCase();
    }
    return firebaseUser.uid.slice(0, 8);
  };

  const userName = getUserName(user);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        await checkUserActivation(currentUser.uid);
        await loadTopicResults(getUserName(currentUser));
      } else {
        setUser(null);
        setIsActivated(false);
        setLoading(false);
      }
    });
    return () => unsubscribe();
  }, []);

  // YENI: Modal açılanda input focus
  useEffect(() => {
    if (showActivationModal && activationInputRef.current) {
      setTimeout(() => {
        activationInputRef.current?.focus();
      }, 100);
    }
  }, [showActivationModal]);

  const loadTopicResults = async (uName) => {
    try {
      const q = query(collection(db, 'topicAssessments'), where('userName', '==', uName));
      const snapshot = await getDocs(q);
      const results = {};
      snapshot.forEach(doc => {
        const data = doc.data();
        results[data.topicId] = data;
      });
      setTopicResults(results);
    } catch (err) {
      console.error('Load results error:', err);
    }
  };

  const checkUserActivation = async (userId) => {
    try {
      const codeRef = doc(db, 'users', userId, 'activationCodes', COURSE_ID);
      const codeSnap = await getDoc(codeRef);
      if (codeSnap.exists()) {
        const data = codeSnap.data();
        setActivationData(data);
        if (data.status === 'active') {
          setIsActivated(true);
          setCurrentMonth(data.currentMonth || 1);
        } else {
          setIsActivated(false);
        }
      } else {
        setIsActivated(false);
      }
    } catch (error) {
      console.error('Activation check error:', error);
    } finally {
      setLoading(false);
    }
  };

  const activateCourse = async (inputCode) => {
    setActivationError('');
    if (!user) {
      setActivationError('Əvvəlcə daxil olun');
      return false;
    }
    try {
      const codeRef = doc(db, 'activationCodes', inputCode.toUpperCase());
      const codeSnap = await getDoc(codeRef);
      if (!codeSnap.exists()) {
        setActivationError('Yanlış kod');
        return false;
      }
      const codeData = codeSnap.data();
      if (codeData.course !== COURSE_ID) {
        setActivationError('Bu kod bu kurs üçün deyil');
        return false;
      }
      if (codeData.userId !== user.uid) {
        setActivationError('Bu kod sizə aid deyil');
        return false;
      }
      if (codeData.status === 'used' || codeData.status === 'expired') {
        setActivationError('Kod istifadə olunub');
        return false;
      }
      const updateData = {
        status: 'active',
        activatedAt: serverTimestamp(),
        currentMonth: 1,
        'payment.status': 'pending'
      };
      await updateDoc(codeRef, updateData);
      await updateDoc(doc(db, 'users', user.uid, 'activationCodes', COURSE_ID), updateData);
      setIsActivated(true);
      setCurrentMonth(1);
      setActivationData({ ...codeData, ...updateData });
      setShowActivationModal(false); // Modalı bağla
      return true;
    } catch (error) {
      console.error('Activation error:', error);
      setActivationError('Sistem xətası');
      return false;
    }
  };

  // YENI: Mobil menyu bağlanıb modal açmaq
  const openActivationModal = () => {
    setIsMobileMenuOpen(false);
    setTimeout(() => {
      setShowActivationModal(true);
    }, 300);
  };

  const checkAccess = () => {
    if (currentTopic === 0) return true;
    if (isActivated) return true;
    return false;
  };

  const handleAssessmentComplete = (result) => {
    setTopicResults(prev => ({ ...prev, [result.topicId]: result }));
    setActiveTab('analysis');
  };

  const hasAccess = checkAccess();
  const currentTopicData = topics[currentTopic] || topics[0];

  if (loading) return <div className="loading-screen">Yüklənir...</div>;

  return (
    <div className="ai-course">
      {/* Header */}
      <header className="course-header">
        <div className="header-left">
          <button 
            className={`hamburger-btn ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </button>
          <h1>🤖 Python AI Kursu</h1>
          {user && <span className="user-badge">👤 {userName}</span>}
        </div>
        <div className="header-actions">
          <a href="/" className="home-btn">🏠 Ana Səhifə</a>
          {isActivated ? (
            <span className="badge activated">✓ Aktiv (Ay {currentMonth})</span>
          ) : (
            <span className="badge inactive">🔒 Deaktiv</span>
          )}
        </div>
      </header>

      {/* YENI: Aktivləşdirmə Modalı */}
      {showActivationModal && (
        <div 
          className="activation-modal-overlay" 
          onClick={() => setShowActivationModal(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.8)',
            zIndex: 3000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '1rem'
          }}
        >
          <div 
            className="activation-modal-content" 
            onClick={e => e.stopPropagation()}
            style={{
              background: 'white',
              borderRadius: '16px',
              padding: '2rem',
              maxWidth: '400px',
              width: '100%',
              boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
            }}
          >
            <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
              <div style={{ 
                width: '80px', 
                height: '80px', 
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1rem',
                fontSize: '2.5rem'
              }}>
                🔒
              </div>
              <h2 style={{ margin: 0, color: '#1a202c' }}>Kursu Aktivləşdir</h2>
              <p style={{ color: '#718096', margin: '0.5rem 0 0 0' }}>
                {currentTopicData?.title || 'Mövzu'} üçün aktivləşdirmə kodu tələb olunur
              </p>
            </div>

            <div style={{ marginBottom: '1rem' }}>
              <label style={{ display: 'block', marginBottom: '0.5rem', color: '#4a5568', fontWeight: '500' }}>
                Aktivləşdirmə Kodu
              </label>
              <input
                ref={activationInputRef}
                type="text"
                value={accessCode}
                onChange={(e) => setAccessCode(e.target.value)}
                placeholder="Kodu daxil edin (məs: AI2024)"
                style={{
                  width: '100%',
                  padding: '0.875rem',
                  border: '2px solid #e2e8f0',
                  borderRadius: '8px',
                  fontSize: '1rem',
                  textTransform: 'uppercase',
                  letterSpacing: '1px'
                }}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    activateCourse(accessCode);
                  }
                }}
              />
            </div>

            {activationError && (
              <div style={{ 
                background: '#fed7d7', 
                color: '#c53030', 
                padding: '0.75rem', 
                borderRadius: '8px', 
                marginBottom: '1rem',
                fontSize: '0.875rem'
              }}>
                ⚠️ {activationError}
              </div>
            )}

            <button
              onClick={() => activateCourse(accessCode)}
              disabled={!accessCode.trim()}
              style={{
                width: '100%',
                padding: '1rem',
                background: accessCode.trim() ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : '#cbd5e0',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '1rem',
                fontWeight: '600',
                cursor: accessCode.trim() ? 'pointer' : 'not-allowed',
                marginBottom: '0.75rem'
              }}
            >
              Aktivləşdir
            </button>

            <button
              onClick={() => setShowActivationModal(false)}
              style={{
                width: '100%',
                padding: '0.875rem',
                background: 'transparent',
                color: '#718096',
                border: '1px solid #e2e8f0',
                borderRadius: '8px',
                fontSize: '0.875rem',
                cursor: 'pointer'
              }}
            >
              İmtina et
            </button>

            <p style={{ 
              textAlign: 'center', 
              marginTop: '1rem', 
              fontSize: '0.75rem', 
              color: '#a0aec0' 
            }}>
              Nümunə kod formatı: AI2024, LUMINA100
            </p>
          </div>
        </div>
      )}

      {/* Mobile Menu */}
      <div 
        className={`menu-overlay ${isMobileMenuOpen ? 'active' : ''}`} 
        onClick={() => setIsMobileMenuOpen(false)}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0,0,0,0.5)',
          zIndex: 1500,
          opacity: isMobileMenuOpen ? 1 : 0,
          visibility: isMobileMenuOpen ? 'visible' : 'hidden',
          transition: 'all 0.3s ease'
        }}
      />
      
      <nav 
        className={`mobile-menu-drawer ${isMobileMenuOpen ? 'active' : ''}`}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          bottom: 0,
          width: '280px',
          background: 'white',
          zIndex: 2000,
          transform: isMobileMenuOpen ? 'translateX(0)' : 'translateX(-100%)',
          transition: 'transform 0.3s ease',
          overflowY: 'auto'
        }}
      >
        <div className="drawer-header" style={{ padding: '1.5rem', borderBottom: '1px solid #e2e8f0' }}>
          <div className="drawer-brand" style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <div className="drawer-brand-icon" style={{ fontSize: '2rem' }}>🤖</div>
            <div className="drawer-brand-text">
              <h2 style={{ margin: 0, fontSize: '1.25rem' }}>AI Kursu</h2>
              <p style={{ margin: 0, color: '#718096', fontSize: '0.875rem' }}>Mövzu {currentTopic + 1} / 20</p>
            </div>
          </div>
          <button 
            className="close-drawer" 
            onClick={() => setIsMobileMenuOpen(false)}
            style={{
              position: 'absolute',
              top: '1rem',
              right: '1rem',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '0.5rem'
            }}
          >
            <X size={24}/>
          </button>
        </div>

        <div className="drawer-content" style={{ padding: '1rem' }}>
          <div className="drawer-section" style={{ marginBottom: '1.5rem' }}>
            <div className="drawer-section-title" style={{ 
              fontSize: '0.75rem', 
              textTransform: 'uppercase', 
              color: '#718096', 
              marginBottom: '0.75rem',
              fontWeight: '600'
            }}>
              🧭 Naviqasiya
            </div>
            <div className="drawer-nav" style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              {NAV_ITEMS.map((item) => (
                <button
                  key={item.id}
                  className={`drawer-nav-item ${activeTab === item.id ? 'active' : ''}`}
                  onClick={() => {
                    setActiveTab(item.id);
                    setIsMobileMenuOpen(false);
                  }}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem',
                    padding: '0.75rem',
                    borderRadius: '8px',
                    border: 'none',
                    background: activeTab === item.id ? '#667eea' : 'transparent',
                    color: activeTab === item.id ? 'white' : '#4a5568',
                    cursor: 'pointer',
                    textAlign: 'left',
                    fontSize: '0.9375rem'
                  }}
                >
                  <span className="drawer-nav-icon">{item.emoji}</span>
                  <span className="drawer-nav-label" style={{ flex: 1 }}>{item.label}</span>
                  {activeTab === item.id && <ChevronRight size={18} />}
                </button>
              ))}
            </div>
          </div>

          <div className="drawer-section" style={{ marginBottom: '1.5rem' }}>
            <div className="drawer-section-title" style={{ 
              fontSize: '0.75rem', 
              textTransform: 'uppercase', 
              color: '#718096', 
              marginBottom: '0.75rem',
              fontWeight: '600'
            }}>
              📖 AI Mövzuları (Ay 1)
            </div>
            <div className="drawer-topics" style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
              {topics.map((topic, idx) => {
                const isLocked = !isActivated && idx !== 0;
                const isActive = currentTopic === idx;
                const hasResult = topicResults[idx + 1];
                return (
                  <button
                    key={idx}
                    className={`drawer-topic-item ${isActive ? 'active' : ''} ${isLocked ? 'locked' : ''}`}
                    onClick={() => {
                      if (!isLocked) {
                        setCurrentTopic(idx);
                        setActiveTab('content');
                        setIsMobileMenuOpen(false);
                      } else {
                        // YENI: Kilidli mövzuya klikləndikdə modal aç
                        openActivationModal();
                      }
                    }}
                    disabled={false} // Kilidli olsa belə kliklənə bilər (modal açılacaq)
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: '0.75rem',
                      borderRadius: '8px',
                      border: 'none',
                      background: isActive ? '#edf2f7' : 'transparent',
                      color: isLocked ? '#a0aec0' : isActive ? '#667eea' : '#4a5568',
                      cursor: 'pointer',
                      textAlign: 'left',
                      width: '100%',
                      opacity: isLocked ? 0.7 : 1
                    }}
                  >
                    <div className="topic-main" style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                      <span 
                        className={`drawer-topic-number ${isActive ? 'active' : ''}`}
                        style={{
                          width: '28px',
                          height: '28px',
                          borderRadius: '50%',
                          background: isActive ? '#667eea' : isLocked ? '#e2e8f0' : '#edf2f7',
                          color: isActive ? 'white' : isLocked ? '#a0aec0' : '#4a5568',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '0.75rem',
                          fontWeight: '600'
                        }}
                      >
                        {idx + 1}
                      </span>
                      <span className="drawer-topic-name" style={{ fontSize: '0.875rem' }}>{topic?.title || `Mövzu ${idx + 1}`}</span>
                    </div>
                    <div className="drawer-topic-badge">
                      {idx === 0 && <span className="free-badge" style={{ 
                        fontSize: '0.625rem', 
                        background: '#48bb78', 
                        color: 'white',
                        padding: '0.125rem 0.5rem',
                        borderRadius: '4px'
                      }}>FREE</span>}
                      {hasResult && <span className="completed-check" style={{ color: '#48bb78' }}>✓</span>}
                      {isLocked && <LockIcon size={16} style={{ color: '#a0aec0' }}/>}
                    </div>
                  </button>
                );
              })}
            </div>
          </div>

          <div className="drawer-section">
            <div className="drawer-section-title" style={{ 
              fontSize: '0.75rem', 
              textTransform: 'uppercase', 
              color: '#718096', 
              marginBottom: '0.75rem',
              fontWeight: '600'
            }}>
              📅 Gələcək Aylar
            </div>
            <div className="months-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '0.5rem' }}>
              {[2, 3, 4, 5, 6].map((ay) => (
                <button key={ay} disabled style={{ 
                  padding: '0.75rem',
                  borderRadius: '8px',
                  border: '1px solid #e2e8f0',
                  background: '#f7fafc',
                  color: '#a0aec0',
                  cursor: 'not-allowed',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: '0.25rem'
                }}>
                  <LockIcon size={16} />
                  <span style={{ fontSize: '0.875rem', fontWeight: '500' }}>Ay {ay}</span>
                  <small style={{ fontSize: '0.625rem' }}>Tezliklə</small>
                </button>
              ))}
            </div>
          </div>
        </div>
      </nav>

      {/* Desktop Layout */}
      <div className="course-layout" style={{ display: 'flex', minHeight: 'calc(100vh - 64px)' }}>
        <aside className="desktop-sidebar" style={{ 
          width: '280px', 
          background: '#f7fafc',
          borderRight: '1px solid #e2e8f0',
          display: 'none' // Mobil üçün gizli, desktop üçün CSS-də göstəriləcək
        }}>
          <div className="desktop-sidebar-header" style={{ padding: '1.5rem', borderBottom: '1px solid #e2e8f0' }}>
            <h3>📚 AI Mövzuları</h3>
            <span className="month-label">Ay 1</span>
          </div>
          <div className="desktop-topics-list">
            {topics.map((topic, idx) => {
              const hasResult = topicResults[idx + 1];
              return (
                <button
                  key={idx}
                  className={`desktop-topic-item ${currentTopic === idx ? 'active' : ''}`}
                  onClick={() => {
                    setCurrentTopic(idx);
                    setActiveTab('content');
                  }}
                >
                  <span className="topic-number">{idx + 1}</span>
                  <span className="topic-name">{topic?.title || `Mövzu ${idx + 1}`}</span>
                  {hasResult && <CheckCircle2 size={16} className="check-icon" />}
                </button>
              );
            })}
          </div>

          <div className="desktop-months">
            <div className="desktop-months-title">📅 Gələcək Aylar</div>
            <div className="desktop-months-grid">
              {[2, 3, 4, 5, 6].map((ay) => (
                <div key={ay} className="desktop-month-btn">
                  <span><LockIcon size={14} /> Ay {ay}</span>
                  <small>Tezliklə</small>
                </div>
              ))}
            </div>
          </div>
        </aside>

        <main className="content-area" style={{ flex: 1, padding: '1.5rem' }}>
          {/* Desktop Tabs */}
          <div className="desktop-tabs" style={{ 
            display: 'flex', 
            gap: '0.5rem', 
            marginBottom: '1.5rem',
            borderBottom: '2px solid #e2e8f0',
            overflowX: 'auto'
          }}>
            {NAV_ITEMS.map((item) => (
              <button 
                key={item.id} 
                className={activeTab === item.id ? 'active' : ''} 
                onClick={() => setActiveTab(item.id)}
                style={{
                  padding: '0.75rem 1rem',
                  border: 'none',
                  background: 'none',
                  borderBottom: activeTab === item.id ? '2px solid #667eea' : 'none',
                  color: activeTab === item.id ? '#667eea' : '#718096',
                  cursor: 'pointer',
                  fontWeight: activeTab === item.id ? '600' : '400',
                  whiteSpace: 'nowrap'
                }}
              >
                {item.emoji} {item.label}
              </button>
            ))}
          </div>

          {!hasAccess ? (
            <div className="access-lock" style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              minHeight: '60vh',
              textAlign: 'center',
              padding: '2rem'
            }}>
              <div className="lock-icon" style={{ fontSize: '4rem', marginBottom: '1rem' }}>🔒</div>
              <h2>Mövzu {currentTopic + 1}: {currentTopicData?.title || 'Kilidli Mövzu'}</h2>
              <p style={{ color: '#718096', marginBottom: '2rem' }}>Bu mövzuya baxmaq üçün aktivləşdirmə kodu tələb olunur</p>
              
              {/* YENI: Desktop üçün sadə form, mobil üçün modal düyməsi */}
              <div className="activation-form" style={{ maxWidth: '400px', width: '100%' }}>
                <input 
                  type="text" 
                  placeholder="Aktivləşdirmə kodunu daxil edin" 
                  value={accessCode} 
                  onChange={(e) => setAccessCode(e.target.value)} 
                  style={{
                    width: '100%',
                    padding: '0.875rem',
                    border: '2px solid #e2e8f0',
                    borderRadius: '8px',
                    marginBottom: '1rem',
                    fontSize: '1rem'
                  }}
                />
                <button 
                  onClick={() => activateCourse(accessCode)}
                  style={{
                    width: '100%',
                    padding: '1rem',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '1rem',
                    fontWeight: '600',
                    cursor: 'pointer'
                  }}
                >
                  Aktivləşdir
                </button>
                {activationError && <p className="error-text" style={{ color: '#e53e30', marginTop: '1rem' }}>{activationError}</p>}
                <p className="help-text" style={{ color: '#a0aec0', fontSize: '0.875rem', marginTop: '1rem' }}>Nümunə kod formatı: AI2024</p>
              </div>
            </div>
          ) : (
            <>
              <div className="topic-header" style={{ marginBottom: '1.5rem' }}>
                <h2>Mövzu {currentTopic + 1}: {currentTopicData?.title || 'Mövzu'}</h2>
                <span className="duration">⏱️ {currentTopicData?.duration || '0 dəq'}</span>
              </div>

              <div className="tab-content">
                {activeTab === 'content' && (
                  <div className="content-section">
                    <div className="info-banner content" style={{
                      background: '#ebf8ff',
                      border: '1px solid #90cdf4',
                      borderRadius: '8px',
                      padding: '1rem',
                      marginBottom: '1.5rem'
                    }}>
                      <div className="info-banner-header" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                        <BookOpen size={24} color="#3182ce" />
                        <h3 style={{ margin: 0, color: '#2c5282' }}>Məzmun Bölməsi</h3>
                      </div>
                      <p style={{ margin: 0, color: '#2c5282' }}>Burada mövzu haqqında sadə, detallı məlumat əldə edəcəksiniz. 
                        Zəhmət olmasa diqqətlə oxuyun və anlamadığınız yerləri qeyd edin.</p>
                    </div>

                    <div className="content-html" dangerouslySetInnerHTML={{ __html: currentTopicData?.content || '<p>Məzmun yüklənir...</p>' }} />
                    
                    <div className="cta-section" style={{
                      textAlign: 'center',
                      padding: '3rem',
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      borderRadius: '16px',
                      color: 'white',
                      marginTop: '2rem'
                    }}>
                      <Zap size={48} style={{ marginBottom: '1rem' }} />
                      <h3>Biliklərini Yoxla</h3>
                      <p>15 suallıq dəqiq quiz və 2 sadə kod tapşırığı</p>
                      <button onClick={() => setActiveTab('quiz')} style={{
                        padding: '1rem 2rem',
                        background: 'white',
                        color: '#667eea',
                        border: 'none',
                        borderRadius: '8px',
                        fontSize: '1rem',
                        fontWeight: '600',
                        cursor: 'pointer',
                        marginTop: '1rem'
                      }}>
                        <Target size={20} style={{ display: 'inline', marginRight: '0.5rem' }} /> Özünü Yoxla
                      </button>
                    </div>
                  </div>
                )}

                {activeTab === 'quiz' && (
                  <TopicAssessment
                    topic={currentTopicData}
                    topicIndex={currentTopic}
                    user={user}
                    userName={userName}
                    onComplete={handleAssessmentComplete}
                    setActiveTab={setActiveTab}
                  />
                )}

                {activeTab === 'practice' && (
                  <PracticeSection
                    topic={currentTopicData}
                    user={user}
                    userName={userName}
                    topicId={currentTopic + 1}
                  />
                )}

                {activeTab === 'editor' && (
                  <div className="editor-tab">
                    <div className="info-banner editor" style={{
                      background: '#f0fff4',
                      border: '1px solid #9ae6b4',
                      borderRadius: '8px',
                      padding: '1rem',
                      marginBottom: '1.5rem'
                    }}>
                      <div className="info-banner-header" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                        <Code2 size={24} color='#38a169' />
                        <h3 style={{ margin: 0, color: '#276749' }}>Sərbəst Kod Editoru</h3>
                      </div>
                      <p style={{ margin: 0, color: '#276749' }}>Bu əlavə məşq üçün kodlar yazmaqınız üçün sadə editordur.</p>
                    </div>

                    <div className="editor-container">
                      <Editor 
                        mode="editor"
                        starterCode={`# ${currentTopicData?.title || 'Mövzu'} mövzusu üzrə məşq\n# Kodunuzu bura yazın\n\nprint("Salam Dünya!")`}
                        userId={user?.uid}
                        userName={userName}
                        courseId={COURSE_ID}
                        topicId={currentTopic + 1}
                      />
                    </div>
                  </div>
                )}

                {activeTab === 'analysis' && (
                  <AnalysisDashboard userName={userName} />
                )}

                {activeTab === 'videos' && (
                  <VideoSection topicId={currentTopic + 1} />
                )}
              </div>
            </>
          )}
        </main>
      </div>

      {/* Chatbot */}
      <Chatbot topic={currentTopicData} />
    </div>
  );
};

export default AI;